var _path, _path2, _rect, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMp4 = function SvgMp4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mp4_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    fillRule: "evenodd",
    d: "M15 24h24v1.5h-.75V27H39v9h-.75v1.5H39V39H15v-1.5h.75V36H15v-9h.75v-1.5H15zm2.25 3h1.5v-1.5h-1.5zm3 0h1.5v-1.5h-1.5zm3 0h1.5v-1.5h-1.5zm3 0h1.5v-1.5h-1.5zm3 0h1.5v-1.5h-1.5zm3 0h1.5v-1.5h-1.5zm3 0h1.5v-1.5h-1.5zm-18 9v1.5h1.5V36zm3 0v1.5h1.5V36zm3 0v1.5h1.5V36zm3 0v1.5h1.5V36zm3 0v1.5h1.5V36zm3 0v1.5h1.5V36zm3 0v1.5h1.5V36zm-4.5-4.5-6 3v-6z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#18BBF7",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.69 12h2.028l1.394 3.398h.07L11.577 12h2.027v6h-1.593v-3.469h-.047l-1.336 3.422h-.961L8.33 14.508h-.047V18H6.69zm7.686 6v-6h2.59q.668 0 1.17.264.5.264.778.74.279.479.279 1.117 0 .645-.287 1.116-.285.472-.8.727-.513.255-1.198.255H15.36v-1.266h1.218q.288 0 .49-.1a.73.73 0 0 0 .313-.29.85.85 0 0 0 .111-.442.83.83 0 0 0-.11-.44.7.7 0 0 0-.314-.28 1.1 1.1 0 0 0-.49-.1h-.574V18zm5.368-.937v-1.266L22.158 12h1.148v1.688h-.656l-1.301 2.062v.047h3.563v1.265zm2.918.937v-1.324l.035-.551V12h1.523v6z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mp4_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgMp4;